import { Directive, ElementRef, Inject, Input } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Directive({
  selector: '[appResponsiveBreakpoint]'
})
export class ResponsiveBreakpointDirective {
  @Input() screen: string;

  constructor(public element: ElementRef) { }

}



// WEBPACK FOOTER //
// ./src/app/system/core/responsive-breakpoints/responsive-breakpoint.directive.ts